// styles.ts
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Colors, FontWeight, Breakpoints } from '../../../../../assets/styles';

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    width: '50%',
    // [theme.breakpoints.down(Breakpoints.MD)]: {
    //   width: '100%',
    // },
  },
  input: {
    marginBottom: '25px !important',
  },
  select: {
    marginBottom: '25px !important',
    '& label': {
      color: Colors.Blue,
    },
  },
  datePickerWrapper: {
    marginBottom: 25,
  },
  datePickerText: {
    '&.MuiTypography-root':{
      fontSize: 16,
      color: Colors.Blue,
      fontWeight: FontWeight.Bold,
      margin: 0,
      marginBottom: 16,
    },
  },
  datePickerContainer: {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: 7,
    '& $datePickerLabel:first-child': {
      marginLeft: 0,
    },
  },
  datePickerLabel: {
    fontSize: 16,
    fontWeight: FontWeight.Bold,
    color: Colors.Gray,
    margin: '0 11px',
  },
  readOnlyPicker: {
    border: 'none',
    '& button': {
      display: 'none',
    },
    '& input': {
      color: Colors.Black,
      paddingLeft: 10,
      fontWeight: FontWeight.Bold,
    },
  },
}));

export default useStyles;
